import { Injectable } from "@angular/core";
import { ThemeStore } from "@stores";

@Injectable()
export class ThemeService {
	// Theme assets keep their filenames, and deployments may skip the app-version bump.
	// Refresh them on each app load while retaining caching when switching themes.
	private readonly themeCacheKey = Date.now().toString();

	constructor(private themeStore: ThemeStore) { }
	loadTheme(themeName = null): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			document.body.style.visibility = "hidden";

			if (!themeName)
				themeName = localStorage.getItem("theme") || "default"

			if (themeName === "undefined")
				themeName = "default";

			(<HTMLLinkElement>document.getElementById('user-theme-overrides')).href = `/content/themes/${themeName}-overrides.css?v=${this.themeCacheKey}`;
			(<HTMLLinkElement>document.getElementById('user-theme')).href = `/content/themes/${themeName}/bootstrap.min.css?v=${this.themeCacheKey}`;

			// A little hacky, but there's no good way to know when the style has loaded,
			// so we check the stylesheets to see if the one we want is loaded 
			let infLoopCheck = 500;
			let themeVisibleInterval: NodeJS.Timer = setInterval(() => {
				let bootstrapStyleSheet;
				for (let i = 0; i < document.styleSheets.length; i++) {
					if (document.styleSheets.item(i).href && document.styleSheets.item(i).href.indexOf("/content/themes/" + themeName + "/bootstrap.min.css") >= 0)
						bootstrapStyleSheet = document.styleSheets.item(i);
				}
				infLoopCheck--;
				if (infLoopCheck === 0 || bootstrapStyleSheet) {
					if (infLoopCheck === 0)
						console.error("theme loader timed out");
					document.body.style.visibility = "visible";
					clearInterval(themeVisibleInterval);
					this.themeStore.setTheme(themeName);
					resolve();
				}
			}, 100)
		})
	}
}
